module.exports = __webpack_public_path__ + "img/googlereviewsp7.71d5b719.png";